


















import { Component, Prop, Vue } from 'vue-property-decorator';
import { OnValidatedCallback } from '../../types/constants';

export enum CheckboxSizes {
  Normal = 'normal',
  Small = 'small',
  Square = 'square'
}

const BOUNCE_ANIMATION_DURATION = 500;

// Copied from ui-kit and modified (added shaking animation)
@Component
export default class Checkbox extends Vue {
  @Prop() name!: string;

  @Prop({ default: true }) enabled!: boolean;

  @Prop({ default: false }) selected!: boolean;

  @Prop({ default: true }) validState!: boolean;

  @Prop({ default: false }) enableValidation!: boolean;

  @Prop({ default: CheckboxSizes.Normal }) size!: CheckboxSizes;

  @Prop({ default: '' }) backgroundColor!: string;

  selfSelected = this.selected;

  selfSize = this.size;

  selfBackgroundColor = this.backgroundColor;

  isValid = true;

  isBouncing = false;

  get styles() {
    const styles = {
      backgroundColor: ''
    };

    if (!this.selfSelected && this.selfBackgroundColor) {
      styles.backgroundColor = this.selfBackgroundColor;
    }

    return styles;
  }

  created() {
    if (this.enableValidation && this.$parent) {
      this.$parent.$on(`validate:${this.name}`, (done: OnValidatedCallback) =>
        done(this.validate()));
    }
  }

  validate(): Promise<boolean> {
    let isValid = true;
    if (this.selfSelected !== this.validState) {
      isValid = false;
    }

    this.updateValidity(isValid);
    return Promise.resolve(isValid);
  }

  updateValidity(validity: boolean): void {
    if (!validity) {
      this.bounceError();
    }

    this.isValid = validity;
  }

  bounceError() {
    this.isBouncing = true;
    setTimeout(() => {
      this.isBouncing = false;
    }, BOUNCE_ANIMATION_DURATION);
  }

  onChange() {
    if (this.enabled) {
      this.selfSelected = !this.selfSelected;
      this.$emit('update:selected', this.selfSelected);
      this.$emit('change', { selected: this.selfSelected });

      if (this.enableValidation) {
        this.validate();
      }
    }
  }
}
